import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getFixRouteString, getActiveTabIdList } from "../Utils";
import { NAVBAR_MINIMIZER_ROUTES_PREFIX } from "../Constants";

export function useActiveTab({
  handleTabStateChange,
  currentActiveTab,
  currentActiveSubTab,
  setExpanded,
  setHideToggler,
}) {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname) {
      const routePrefix = getFixRouteString(location.pathname);
      let [activeTabId, activeSubTabId] = getActiveTabIdList(routePrefix) || [];
      activeTabId = activeTabId ?? null;
      activeSubTabId = activeSubTabId ?? null;

      // set Active Tab( or Sub Tab) on route change
      if (activeTabId !== currentActiveTab || activeSubTabId !== currentActiveSubTab) {
        handleTabStateChange({
          activeSubTabId,
          activeTabId,
          ...activeSubTabId !== null ? { expandedParentTabId: activeTabId } : {},
        });
      }

      // minimize navbar on some selective routes
      const shouldMinimizeNavbar = NAVBAR_MINIMIZER_ROUTES_PREFIX.includes(routePrefix);
      setHideToggler(shouldMinimizeNavbar);
      setExpanded(!shouldMinimizeNavbar);
    }
  }, [location.pathname]);

  return null;
}
